var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcodeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.16667V0.5H6.66667V7.16667H0ZM2.5 3V4.66667H4.16667V3H2.5Z",
    fill: "#EAF1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 7.16667V0.5H14.9987V7.16667H8.33203ZM10.832 3V4.66667H12.4987V3H10.832Z",
    fill: "#EAF1FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.83301V15.4997H6.66667V8.83301H0ZM4.16667 11.333V12.9997H2.5V11.333H4.16667Z",
    fill: "#EAF1FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.832 8.83301H8.33203V10.4997H10.832V13.833H9.9987V12.1663H8.33203V15.4997H11.6654V13.833H13.332V15.4997H14.9987V12.9997H13.332V12.1663H12.4987V11.333H14.9987V8.83301H12.4987V10.4997H10.832V8.83301Z",
    fill: "#EAF1FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeWhite);
export default __webpack_public_path__ + "static/media/qrcode-white.8c61b103d8d307fc16d05e317ae5c2b2.svg";
export { ForwardRef as ReactComponent };